module.exports = __webpack_public_path__ + "static/media/sonyproduct1banner.218f1724.jpg";